import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel, FormGroup,
  Grid,
} from '@material-ui/core';
import Reviews from './reviews_tab/Reviews';
import { observer } from 'mobx-react';

const ReviewsTab = observer(({mainBookFormStore}) => {
  const handleCheckboxChange = (event) => {
    mainBookFormStore.setShowReviews(!event.target.checked);
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel control={<Checkbox checked={!mainBookFormStore.showReviews} onChange={handleCheckboxChange} />} label="Livro sem reviews" />
            </FormGroup>
            {mainBookFormStore.showReviews && <Reviews mainBookFormStore={mainBookFormStore} />}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default ReviewsTab;
